import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../common/icon/icon.component.jsx';
import Integrations from '../../../integration/Integrations.jsx';

class InvoiceFullyPaidEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
        })
    }

    render() {

        const invoice = this.state.invoice ? this.state.invoice : this.state.object
        const integrationKey = invoice.attributes.importedFrom
        if (!integrationKey) {
            return ""
        }

        const integrationName = Integrations.getIntegrationNameFromKey(integrationKey)

        const importMessage =
            <FormattedMessage
                id="invoice.analytics.events.imported_for_integration.text"
                defaultMessage="Invoice {identifier} has been imported from {integrationName}"
                values={{
                    identifier: <strong>{invoice.attributes.identifier}</strong>,
                    integrationName: integrationName
                }} />

        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-center'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0"}>
                        <Icon value={"cloud-download-alt"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-0'}>
                        {importMessage}
                    </p>
                </div>
            </div>
        </div>
    }

}

export default InvoiceFullyPaidEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-imported.component.jsx